import { Link, useLocation } from "react-router-dom";
import { Sparkles, ArrowRight } from "lucide-react";
import { Button } from "../../components/ui/button";

// Friendly placeholder for seller routes whose feature is on the roadmap but
// not yet shipped (RFQ, Inventory, Reports, AI Assistant). The same component
// is reused for all four — we infer the feature name from the URL.
const TITLES = {
  rfq:        { name: "RFQ — Request for Quote", desc: "Receive and respond to buyer RFQs in one inbox." },
  inventory:  { name: "Inventory & Warehousing", desc: "Track stock across warehouses with reorder alerts." },
  reports:    { name: "Reports & Analytics",     desc: "Margin, velocity, COGS and supplier-performance dashboards." },
  ai:         { name: "AI Assistant",            desc: "Read POs, draft messages, and answer buyer questions." },
};

export default function SellerComingSoon() {
  const { pathname } = useLocation();
  const key = pathname.split("/").filter(Boolean).pop() || "rfq";
  const meta = TITLES[key] || TITLES.rfq;

  return (
    <div className="min-h-[80vh] grid place-items-center px-8" data-testid="seller-coming-soon">
      <div className="max-w-md text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-foreground/5 border border-border text-[11px] mono uppercase tracking-widest text-foreground/60">
          <Sparkles className="w-3 h-3" />
          Coming soon
        </div>
        <h1 className="display text-4xl mt-6 leading-tight">{meta.name}</h1>
        <p className="text-foreground/65 mt-3 leading-relaxed">{meta.desc}</p>
        <p className="text-[13px] text-foreground/50 mt-6">
          We'll email you the moment this lands. Until then, the rest of your
          portal is fully wired and ready.
        </p>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Button asChild className="rounded-full bg-foreground text-background hover:bg-foreground/90 h-11 px-5">
            <Link to="/seller">
              Back to dashboard <ArrowRight className="w-4 h-4 ml-1.5" />
            </Link>
          </Button>
          <Button asChild variant="outline" className="rounded-full h-11 px-5">
            <Link to="/seller/apps">Browse the App Store</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
